import { useEffect, useState } from "react";
import api from "@/lib/api";
import { inr } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function ProviderBalances() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/finance/provider-balances").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  const total = (rows || []).reduce((a, r) => ({
    gross: a.gross + r.gross, fee: a.fee + r.provider_fee, paid: a.paid + r.paid_out, bal: a.bal + r.balance,
  }), { gross: 0, fee: 0, paid: 0, bal: 0 });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-heading text-2xl font-bold tracking-tight">Bank provider balances report</h2>
        <p className="text-sm text-muted-foreground">Collected volume versus payments made to each provider.</p>
      </div>
      <Card className="p-4">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Bank provider</TableHead>
                <TableHead className="text-right">Transactions</TableHead>
                <TableHead className="text-right">Gross collected</TableHead>
                <TableHead className="text-right">Provider fee</TableHead>
                <TableHead className="text-right">Paid out</TableHead>
                <TableHead className="text-right">Balance</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows === null && <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">Loading…</TableCell></TableRow>}
              {rows && rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">No data yet.</TableCell></TableRow>}
              {rows && rows.map((r) => (
                <TableRow key={r.provider} data-testid={`provider-balance-row-${r.provider}`}>
                  <TableCell className="font-semibold">{r.provider}</TableCell>
                  <TableCell className="text-right font-mono text-xs">{r.count}</TableCell>
                  <TableCell className="text-right font-mono text-xs">{inr(r.gross)}</TableCell>
                  <TableCell className="text-right font-mono text-xs text-warning">{inr(r.provider_fee)}</TableCell>
                  <TableCell className="text-right font-mono text-xs text-muted-foreground">{inr(r.paid_out)}</TableCell>
                  <TableCell className="text-right font-mono text-sm font-semibold">{inr(r.balance)}</TableCell>
                </TableRow>
              ))}
              {rows && rows.length > 0 && (
                <TableRow className="border-t-2 font-semibold">
                  <TableCell>Total</TableCell>
                  <TableCell />
                  <TableCell className="text-right font-mono text-xs">{inr(total.gross)}</TableCell>
                  <TableCell className="text-right font-mono text-xs text-warning">{inr(total.fee)}</TableCell>
                  <TableCell className="text-right font-mono text-xs">{inr(total.paid)}</TableCell>
                  <TableCell className="text-right font-mono text-sm">{inr(total.bal)}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
